import PageHero from "../components/PageHero";
import Seo from "../components/Seo";
import AboutSection from "../components/sections/About";
import { Transparency, SpecialCta } from "../components/sections/CtaSections";
import { Reveal, SectionHeading } from "../components/Reveal";
import { useLang } from "../i18n";
import { useContent } from "../lib/useContent";
import { resolveMedia } from "../lib/api";

function RegistrationInfo() {
  const { pick, lang } = useLang();
  const c = useContent();
  const rows = [
    { label: pick({ hi: "नाम", en: "Name" }), value: lang === "hi" ? c.org_name_hi : c.org_name_en },
    { label: pick({ hi: "पंजीकरण संख्या", en: "Registration Number" }), value: c.reg_no },
    { label: pick({ hi: "स्थापना वर्ष", en: "Year of Establishment" }), value: c.established },
    { label: pick({ hi: "कार्यालय", en: "Office" }), value: lang === "hi" ? c.address_hi : c.address_en },
  ];
  return (
    <section data-testid="registration-section" className="py-24 bg-ngo-cream">
      <div className="max-w-5xl mx-auto px-4 sm:px-6">
        <SectionHeading
          overline={pick({ hi: "आधिकारिक विवरण", en: "Official Details" })}
          title={pick({ hi: "संस्था की जानकारी", en: "Organization Information" })}
          testid="registration-heading"
        />
        <Reveal i={2} className="mt-10">
          <div className="bg-white rounded-3xl border border-ngo-deep/10 shadow-[0_20px_60px_rgba(23,107,58,0.10)] overflow-hidden">
            <img
              src={resolveMedia(c.banner || "/assets/banner.jpg")}
              alt="अंशा वेलफेयर सोसाइटी आधिकारिक बैनर"
              data-testid="registration-banner"
              className="w-full object-cover"
              loading="lazy"
            />
            <div className="p-8 sm:p-10">
              <dl className="divide-y divide-ngo-deep/10">
                {rows.map((r, i) => (
                  <div key={i} className="py-3.5 first:pt-0 last:pb-0 grid sm:grid-cols-[180px_1fr] gap-1">
                    <dt className="text-sm text-ngo-ink/55">{r.label}</dt>
                    <dd data-testid={`reg-row-${i}`} className="text-sm font-semibold text-ngo-ink">{r.value}</dd>
                  </div>
                ))}
              </dl>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}

export default function About() {
  const { pick } = useLang();
  return (
    <main>
      <Seo
        title="हमारे बारे में — Anansha Welfare Society Varanasi"
        description="अंशा वेलफेयर सोसाइटी (Anansha Welfare Society) वाराणसी की पंजीकृत सामाजिक संस्था है — पंजीकरण संख्या VAR/07434/2024-2025, स्थापना 2025। हमारा मिशन, विजन और संस्था की आधिकारिक जानकारी जानें।"
        path="/about"
        breadcrumb={["हमारे बारे में"]}
      />
      <PageHero
        overline={{ hi: "परिचय", en: "Introduction" }}
        title={{ hi: "हमारे बारे में", en: "About Us" }}
        description={{ hi: "सेवा, विश्वास और पारदर्शिता के साथ — समाज के लिए, समाज के साथ।", en: "With service, trust and transparency — for society, with society." }}
        testid="about-page-heading"
      />
      <AboutSection />
      <section className="pb-4 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <Reveal>
            <a href="/founder" data-testid="about-founder-link" className="group inline-flex items-center gap-3 bg-ngo-mint border border-ngo-deep/10 rounded-full px-7 py-4 hover:bg-ngo-deep transition-colors duration-300">
              <span className="font-semibold text-ngo-deep group-hover:text-white transition-colors duration-300">
                {pick({ hi: "हमारी संस्थापक से मिलिए", en: "Meet Our Founder" })}
              </span>
              <span className="text-ngo-deep group-hover:text-ngo-gold group-hover:translate-x-1 transition-[transform,color] duration-300">→</span>
            </a>
          </Reveal>
        </div>
      </section>
      <RegistrationInfo />
      <Transparency />
      <SpecialCta />
    </main>
  );
}
